import React from 'react'

const FormIntro = () => {
  return (
    <div className="relative flex-1 w-full text-center font-poppins mt-[60px] md:mt-[120px] animate-fade-in">
      {/* Welcome Message */}
      <h3 className="text-brandLime font-audiowide uppercase tracking-[0.1em] text-[18px] md:text-[30px]  drop-shadow-sm">
        SMART DEALS, HAPPY TRAVELS
      </h3>

      {/* Main Heading */}
      <h1 className="text-[60px] md:text-[240px] font-bebas leading-none tracking-[0.05em] 
        drop-shadow-[0_10px_10px_rgba(0,0,0,0.5)] bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-[#094A3D]">
        PARKING
      </h1>

      {/* Subtitle */}
      <p className="max-w-3xl mx-auto text-white/80 text-sm md:text-lg leading-relaxed px-4">
        Compare secure airport parking across all major UK airports.<br />
        Save up to 70% on meet & greet, park & ride, and official parking.
      </p>
    </div>
  )
}

export default FormIntro
